module.exports = __webpack_public_path__ + "img/shipo-icon-check-circle.f9037ebb.svg";